module.exports = __webpack_public_path__ + "img/vertical_4_6_9016.16479908.png";